/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductScalePrice
 */
export interface ProductScalePrice {
    /**
     * 
     * @type {number}
     * @memberof ProductScalePrice
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof ProductScalePrice
     */
    discount: number;
    /**
     * 
     * @type {number}
     * @memberof ProductScalePrice
     */
    discountedPrice: number;
}

/**
 * Check if a given object implements the ProductScalePrice interface.
 */
export function instanceOfProductScalePrice(value: object): value is ProductScalePrice {
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('discountedPrice' in value) || value['discountedPrice'] === undefined) return false;
    return true;
}

export function ProductScalePriceFromJSON(json: any): ProductScalePrice {
    return ProductScalePriceFromJSONTyped(json, false);
}

export function ProductScalePriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductScalePrice {
    if (json == null) {
        return json;
    }
    return {
        
        'quantity': json['quantity'],
        'discount': json['discount'],
        'discountedPrice': json['discountedPrice'],
    };
}

export function ProductScalePriceToJSON(json: any): ProductScalePrice {
    return ProductScalePriceToJSONTyped(json, false);
}

export function ProductScalePriceToJSONTyped(value?: ProductScalePrice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quantity': value['quantity'],
        'discount': value['discount'],
        'discountedPrice': value['discountedPrice'],
    };
}

